import React, { useState } from "react";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextInput } from "../../components/Form/Form";
import { login } from "../../store/actions/auth";
import "./login.css";

const Login = ({ login }) => {
  const [submitError, setSubmitError] = useState("");
  const [submitErrorTitle, setSubmitErrorTitle] = useState("");

  return (
    <div className="login-page">
      <div className="login-page__shell">
        <div className="login-page__panel">
          <div className="login-page__form-column">
            <div className="login-page__brand">
              <a href="/" className="login-page__brand-link" aria-label="Go to home">
                <img
                  src="/images/logo.png"
                  alt="Luhaif Digitech"
                  className="login-page__brand-logo"
                />
              </a>
              <span className="login-page__brand-badge">Internal access</span>
            </div>

            <div className="login-page__form-wrap">
              <div className="login-page__intro">
                <p className="login-page__eyebrow">Admin Portal</p>
                <h1>Welcome back</h1>
                <p className="login-page__subtext">
                  Sign in to manage day-to-day operations, performance, and client
                  activity without losing context.
                </p>
              </div>

              {submitError ? (
                <div className="login-page__message login-page__message--error" role="alert">
                  <p className="login-page__message-title">{submitErrorTitle || "Couldn't sign you in"}</p>
                  <p className="login-page__message-copy">{submitError}</p>
                </div>
              ) : null}

              <Formik
                initialValues={{
                  username: "",
                  password: "",
                }}
                validationSchema={Yup.object({
                  username: Yup.string().required("Username is required"),
                  password: Yup.string().required("Password is required"),
                })}
                onSubmit={async (values, { setSubmitting }) => {
                  setSubmitting(true);
                  setSubmitError("");
                  setSubmitErrorTitle("");

                  const result = await login({
                    username: values.username,
                    password: values.password,
                  });

                  if (!result.success) {
                    setSubmitErrorTitle(result.title || "Couldn't sign you in");
                    setSubmitError(result.error);
                    setSubmitting(false);
                  }
                }}
              >
                {(formik) => {
                  return (
                    <Form className="login-page__form" noValidate>
                      <div className="login-page__field">
                        <TextInput
                          label="Username or email"
                          name="username"
                          type="text"
                          placeholder="Enter your username or email"
                        />
                      </div>

                      <div className="login-page__field">
                        <TextInput
                          label="Password"
                          name="password"
                          type="password"
                          placeholder="Enter your password"
                        />
                      </div>

                      <button
                        className="login-page__submit"
                        type="submit"
                        disabled={formik.isSubmitting}
                      >
                        {formik.isSubmitting ? "Signing in..." : "Log In"}
                      </button>
                    </Form>
                  );
                }}
              </Formik>
            </div>

            <p className="login-page__footer">
              Copyright © {new Date().getFullYear()}. All Rights Reserved.
            </p>
          </div>

          <div
            className="login-page__hero"
            aria-hidden="true"
            style={{
              backgroundImage:
                'linear-gradient(180deg, rgba(12, 12, 14, 0.14), rgba(12, 12, 14, 0.58)), url("/images/banner.jpg")',
            }}
          >
            <div className="login-page__hero-overlay" />
            <div className="login-page__hero-content">
              <div className="login-page__hero-frame" />
              <div className="login-page__hero-glow" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  login,
};

export default connect(null, mapDispatchToProps)(Login);
